'use strict'
import CollectionFilters from '~/modules/CollectionFilters'
import CollectionProductTile from '~/modules/CollectionProductTile'

export default class Collections {
    constructor() {
        new CollectionFilters()
        new CollectionProductTile()
    }
}
